import { render, staticRenderFns } from "./Artigo.vue?vue&type=template&id=62931cb8"
import script from "./Artigo.vue?vue&type=script&lang=js"
export * from "./Artigo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports